import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { Link } from 'react-router';
import Pencil from '../svg/pencil';
import Eye from '../svg/eye';
import Trash from '../svg/trash';

export class RegisteredOrdersShowMore extends React.Component {
  static propTypes = {
    deleteInvoice: PropTypes.func.isRequired,
    invoiceId: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    showModal: PropTypes.func.isRequired
  };

  render () {
    return (
      <div className='table-show-more-list'>
        <div
          onClick={this.props.showModal}
          className='table-show-more-list-item hide-desktop'
        >
          <Eye colorSchema='primary' />
          <Translate content='REVIEW_INVOICE' />
        </div>
        <div
          className='table-show-more-list-item'
        >
          <Pencil colorSchema='primary' />
          <Link to={'/register-assignment/' + this.props.invoiceId}>
            <Translate content='EDIT_INVOICE' />
          </Link>
        </div>
        <div
          className='table-show-more-list-item'
          onClick={this.props.deleteInvoice}
        >
          <Trash colorSchema='primary' />
          <Translate content='DELETE' />
        </div>
      </div>
    );
  }
}

export default RegisteredOrdersShowMore;



/** WEBPACK FOOTER **
 ** ./src/components/registered-orders/show-more.js
 **/